import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Blogs from "../components/Blogs";
import { NavLink } from "react-router-dom";
import LandingCarousel from "../components/LandingCarousel";
import NewsletterPopup from "../components/NewsletterPopup";
import NewsLetter from "../components/NewsLetter";
import OurPartners from "../components/OurPartners";
import video from "../assets/video/Outcess-video.mp4";
import ReactPlayer from "react-player";
import Analytics from "../components/Analytics";
import "swiper/css";
import "swiper/css/pagination";
import ServicesWeDeliver from "./ServicesWeDeliver/ServicesWeDeliver";
import Industries from "./Industries/Industries";

const Home = () => {
  const [next, setNext] = useState(false);

  const onClick = (e) => {
    e.preventDefault();
    setNext(true);
  };

  return (
    <div id="home">
      <Navbar />
      <NewsletterPopup />
      <LandingCarousel />

      <main>
        <section>
          <h3 data-aos="fade-in">
            Industries that trust our <span>Services</span>
          </h3>
          <Industries />
        </section>
        <section style={{ width: "100%" }}>
          <div className="deliver_container">
            <h3 data-aos="fade-in">Services We Offer</h3>
            <p>Comprehensive Business Solutions for Digital Transformation</p>
          </div>

          <ServicesWeDeliver />
        </section>
      </main>

      <Analytics />

      <main>
        <section>
          <div className="our-company">
            <div className="our-company-details" data-aos="fade-right">
              <h3>
                Our <span>Company</span>
              </h3>
              <h5>
                For over 15 years we've been able to compete, grow and prosper
                in an accelerating world.
              </h5>
              <p>
                Outcess is an integrated customer engagement and business
                process outsourcing company. We deliver innovative digital
                solutions that empower and optimize the performance of people,
                teams and organizations.
              </p>
              <NavLink to="/about" exact>
                <button>Find Out More</button>
              </NavLink>
            </div>

            {next ? (
              <div className="player-wrapper">
                <ReactPlayer
                  className="react-player"
                  // url='https://youtu.be/UL_Gc5CpPzc'
                  url={video}
                  width="100%"
                  height="100%"
                  playing="true"
                  controls="true"
                  playsinline="true"
                />
              </div>
            ) : (
              <div className="our-company-img" data-aos="fade-left">
                <a
                  href
                  id="play-video"
                  onClick={onClick}
                  class="video-play-button">
                  <span></span>
                </a>
              </div>
            )}
          </div>
          <div></div>
        </section>
        <section>
          <div className="our-partners" data-aos="fade-in">
            <h3>
              Articles in this <span> Edition</span>
            </h3>
          </div>
          <br />
          <div data-aos="fade-up">
            <Blogs />
          </div>
        </section>
        <section>
          <div className="our-partners" data-aos="fade-in">
            <h3>
              Our <span>Partners</span>
            </h3>
          </div>
          <br />
          <div data-aos="fade-up">
            <OurPartners />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};
export default Home;
